module.exports = __webpack_public_path__ + "static/img/zuogengduo.png@2x.6dbbac95.png";